module.exports = __webpack_public_path__ + "static/img/current_location_pointer_new.0f0d440.png";